module.exports = __webpack_public_path__ + "static/media/berry-crushed.3db84644.mp3";